import { render, staticRenderFns } from "./ExamStepOne.vue?vue&type=template&id=1ef505a8&scoped=true&"
import script from "./ExamStepOne.vue?vue&type=script&lang=js&"
export * from "./ExamStepOne.vue?vue&type=script&lang=js&"
import style0 from "./ExamStepOne.vue?vue&type=style&index=0&id=1ef505a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef505a8",
  null
  
)

export default component.exports